import React from 'react';

const Footer = ({ onShowPrivacy, onShowTerms }) => {
  return (
    <footer className="py-6 px-4 sm:px-6 border-t border-gray-200 bg-white mt-auto">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img src="/new_icon+text_color.png" alt="CraftMyParty" className="h-10 w-auto opacity-70" />
            <p className="text-sm text-gray-500">© 2025 CraftMyParty. All rights reserved.</p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm">
            <a
              href="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-purple-600 transition"
            >
              Terms of Service
            </a>
            <a
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-purple-600 transition"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

